module.exports = __webpack_public_path__ + "img/account.32b5de07.png";